var fn = function( obj ){
var __t,__p='';
__p+='\n\nfloat gray = luminance( c );\nc = mix( vec3(gray), c, uSaturation );';
return __p;
};
fn.toString=fn;
module.exports = fn;